module.exports = __webpack_public_path__ + "static/media/sports (7).69c41ce0.webp";